__turbopack_context__.v({
  "appear": "list-module__SmgVWa__appear",
  "blog-date": "list-module__SmgVWa__blog-date",
  "blog-info": "list-module__SmgVWa__blog-info",
  "cover": "list-module__SmgVWa__cover",
  "desc": "list-module__SmgVWa__desc",
  "info": "list-module__SmgVWa__info",
  "title": "list-module__SmgVWa__title",
  "wrapper": "list-module__SmgVWa__wrapper",
});
